import { FIRE_EVENT_ID } from "@dawn/engine";
import type { SoundId } from "./types.ts";

/** Replace files under public/audio/ with final SFX; ids stay stable for policy wiring. */
export const SOUND_ASSET_PATHS: Record<SoundId, string> = {
  victory: "/audio/victory.mp3",
  defeat: "/audio/defeat.mp3",
  tileEnter: "/audio/tileEnter.wav",
  eventFireStart: "/audio/eventFireStart.mp3",
  uiClick: "/audio/uiClick.wav",
};

/** Per-clip gain multiplier (0–1) applied on top of the global volume. */
export const SOUND_GAINS: Partial<Record<SoundId, number>> = {
  eventFireStart: 0.3,
  uiClick: 0.4,
};

export const EVENT_SOUND_IDS: Partial<Record<string, SoundId>> = {
  [FIRE_EVENT_ID]: "eventFireStart",
};
